import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputFile from '../../../FormFields/File';
import InputSelect from '../../../FormFields/Select';

import withConditions from '../withConditions';
import Checkbox from '../../../FormFields/Checkbox';

export class FileEmbeddedWidget extends React.PureComponent {

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Text' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ internalField.description }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputFile label='File' placeholder='Add file' multiple={ false }
                   value={ internalField.embedded }
                   onChange={ (v) => changeFieldValue('embedded', v) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  changeValue = (value) => {
    const { api, field } = this.props;
    field.embedded = value;
    field.changeValues(field);
    api.onFieldValueChange(field.id, field.section, field);
  };

  render() {
    const { field, renderForm, isDisabled } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'File Embedded'
    };
    return (
      <WrapperWidget {...props}>
        <div className='FileEmbeddedWidget'>
          { (field.embedded && field.embedded.length > 0 && field.embedded[0]) &&
          <InputFile
            onChange={ this.changeValue }
            multiple={ false }
            disabled={ isDisabled }
            value={ field.embedded }
          />
          }
        </div>
      </WrapperWidget>
    );
  }
}

export const FileEmbeddedWidgetEditable = withConditions(FileEmbeddedWidget);